// Client helpers for the notification framework: the personal feed, per-type
// channel preferences, and (admin) the catalog. Pairs with push.js, which owns
// the device subscription; this file owns everything above the device layer.

const API = process.env.REACT_APP_API_URL || '';
const opts = (method, body) => ({
  method,
  credentials: 'include',
  headers: { 'Content-Type': 'application/json' },
  ...(body ? { body: JSON.stringify(body) } : {}),
});

// ── Personal feed ──
export async function fetchFeed(limit = 30) {
  const r = await fetch(`${API}/api/notifications?limit=${limit}`, { credentials: 'include' });
  if (!r.ok) throw new Error('Could not load notifications.');
  return r.json(); // { items, unread }
}
export async function markRead({ all, ids } = {}) {
  const r = await fetch(`${API}/api/notifications/read`, opts('POST', all ? { all: true } : { ids }));
  if (!r.ok) throw new Error('Could not update notifications.');
  return r.json();
}
export async function deleteNotification(id) {
  const r = await fetch(`${API}/api/notifications/${id}`, opts('DELETE'));
  if (!r.ok) throw new Error('Could not delete the notification.');
  return r.json();
}
export async function clearNotifications() {
  const r = await fetch(`${API}/api/notifications`, opts('DELETE'));
  if (!r.ok) throw new Error('Could not clear notifications.');
  return r.json();
}
export async function selfTest() {
  const r = await fetch(`${API}/api/notifications/self-test`, opts('POST'));
  if (!r.ok) throw new Error((await r.json().catch(() => ({}))).message || 'Test failed.');
  return r.json();
}

// ── Per-user preferences ──
export async function getPreferences() {
  const r = await fetch(`${API}/api/notifications/preferences`, { credentials: 'include' });
  if (!r.ok) throw new Error('Could not load your notification settings.');
  return r.json(); // { types: [...], settings }
}
export async function savePreferences({ channels, settings }) {
  const r = await fetch(`${API}/api/notifications/preferences`, opts('PUT', { channels, settings }));
  if (!r.ok) throw new Error((await r.json().catch(() => ({}))).message || 'Could not save.');
  return r.json();
}

// ── Admin catalog ──
export async function getCatalog() {
  const r = await fetch(`${API}/api/admin/notifications/catalog`, { credentials: 'include' });
  if (!r.ok) throw new Error('Could not load the catalog.');
  return r.json(); // { catalog, log }
}
export async function setTypeEnabled(key, enabled) {
  const r = await fetch(`${API}/api/admin/notifications/type/${key}`, opts('PUT', { enabled }));
  if (!r.ok) throw new Error('Could not update the type.');
  return r.json();
}
export async function broadcast({ roles, all, title, body, url }) {
  const r = await fetch(`${API}/api/admin/notifications/broadcast`, opts('POST', { roles, all, title, body, url }));
  if (!r.ok) throw new Error((await r.json().catch(() => ({}))).message || 'Broadcast failed.');
  return r.json();
}
export async function flushDigestsNow() {
  const r = await fetch(`${API}/api/admin/notifications/flush-digests`, opts('POST'));
  if (!r.ok) throw new Error('Could not flush digests.');
  return r.json();
}

// Human labels for the channel keys.
export const CHANNEL_LABELS = {
  push: 'Push',
  in_app: 'In-app only',
  digest: 'Daily digest',
  off: 'Off',
};
